import React, { useEffect } from 'react';

import { FormComponentProps } from 'antd/lib/form/Form';
import { useDispatch, useSelector } from 'react-redux';

import {
  dictionariesRequest,
  dictionaryIds,
  dictionaryLoadedSel,
  dictionarySel,
} from '@dict';
import { Form, StateSelect } from '@shared/components';

const FormItem = Form.Item;

interface AddressStateProps {
  form: FormComponentProps['form'];
  disabled: boolean;
  floatingLabel: boolean;
  rounded: boolean;
}

const AddressState: React.FC<AddressStateProps> = ({
  form,
  disabled,
  floatingLabel,
  rounded,
}) => {
  const loaded = useSelector(state =>
    dictionaryLoadedSel(state, dictionaryIds.STATES),
  );
  const states = useSelector(
    state => dictionarySel(state, dictionaryIds.STATES) || [],
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(dictionariesRequest(dictionaryIds.STATES));
  }, [dispatch]);

  const { getFieldDecorator } = form;

  return (
    <FormItem colon={false} validateStatus={loaded ? null : 'validating'}>
      {getFieldDecorator('akelaStateId')(
        <StateSelect
          disabled={disabled}
          size="large"
          states={states}
          statesLoaded={loaded}
          floatingLabel={floatingLabel}
          rounded={rounded}
        />,
      )}
    </FormItem>
  );
};

export default AddressState;
